//import 'typed.js/dist/typed.min.js';

export default {
  init() {
    // JavaScript to be fired on the home page
    // $('#typed-string').typed({
    //   stringsElement: $('#string-to-type'),
    //   shuffle: false,
    //   backSpeed: 0,
    //   loop: false,
    //   typeSpeed: -25
    // })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/Home.js